import {
	getView,
	getTmplName,
	isCustomDataset,
	determine104WeeksFeatureInFilterList
} from 'helper/utils';
import moment from 'moment';
import {
	DC_TMPT_LIST,
	STR_TMPT_LIST,
	ALL_LINK_ITEM_LIST,
	REGISTER_SALES_LIST,
	FUZZY_TMPT_LIST,
	PARENT_CUST_ATTR,
	CUSTOM_ATTRIBUTE,
	STR_DEMAND_LIST,
	ECOM_INVENTORY,
	WM_YR_WK_NO,
	STR_ORDER_LIST,
	SHRINK_WINDOW_RANGE,
	CANNED_REPORT_LIST,
	OTIF_TMPT_LIST,
	BASIC,
	TIME,
	PERSONA,
	SSI_STORE_TRAIT_ATTRS,
	ENTERPRISE_INVENTORY,
	ENTERPRISE_INVENTORY_DEFAULT_FILTER as EIDefaultFilters,
	ITEM_ACCESS_TYPE,
	SSIAllLinkRollupFolders,
	SSIAllLinkRollupViewName,
	SSIAllLinkDetailsViewName,
	FUZZY_OPTIONS,
	FUZZY_CALENDAR,
	YEAR_TO_DATE_KEY,
	DATE_KEY,
	WEEK_KEY,
	MONTH_KEY,
	QUARTER_KEY,
	CUSTOM,
	YEAR_KEY,
	ATTRIBS_LOWERCASE,
	FUZZY_DATE_VALUE,
	WALMART_WEEK_START_DATE,
	BUSINESS_DATE,
	REPORT_DATE,
	PURCHASE_ORDER_LIST,
	GREGORIAN_CALENDAR,
	GREGORIAN_CALENDAR_WEEK,
	PO_DEFAULT_FILTERS,
	MULTI_TIME_SELECTION,
	PIVOT_MTS_VALUE,
	WALMART_CALENDAR,
	PIVOT_SINGLE_TIME_VALUES,
	HAS_ALL_OF,
	TRAIT_NUMBER,
	TRAIT_NBR,
	INVENTORY_DATE,
	MUMD_DATE,
	CUSTOM_ATTRIBUTE_VALUE,
	CUSTOM_ATTRIBUTE_NAME,
	FILTER_CONDITION_LABELS,
	VISIT_LOCAL_DATE,
	SHOW_AS_CANNED_REPORT,
	FUTURE_VALID_LIST,
	CATMAN_USER_ID,
	CAL_ROLL_DAY,
	TENDER_ANALYSIS_LIST,
	SHIP_TO_ZIP_LIST,
	AllLinkRollUp,
	AllLinkRollDetails,
	WM_ITEM_NUMBER_FIELD,
	PIVOT_SINGLE_TIME_VALUE_MAP,
	DATE_KEY_LOWERCASE,
	VARIANT_ATTRTIBUTES,
	VENDOR_NBR,
	VENDOR_NM,
	ECOMM_INSTOCK_LIST,
	WK_SPEC_TMPT,
	CANNED_REPORT_TIME_OPTIONS
} from 'constants/constant';
import { isCalFamily, isMultiWeekSel, isMTS, isMTSAndNotDefault } from './filter/FilterCondition';
import { getDateRange, wkDayRange, getWKWithYrRange, getDateDifference } from 'helper/dateRange';
import { printWeekDays } from 'components/Calendar/calUtil';
import { format2Digit, getPersona, deepClone, contains } from 'helper/helper';
import { getRequestedNoOfWeeks, getConditionFieldFromWeek } from 'helper/dateRange';
import { build } from 'helper/build';
import { _wm } from 'helper/wmDateUtil';

const dateL = 'date';
const dayL = 'day';
const weekL = 'week';
const monthL = 'month';
const quarterL = 'quarter';
const yearL = 'year';

const getFilterForAllLinkActivity = (obj, pLinkItemActivity) => {
	const filterSelection = obj.extraFeatures?.[0];
	const key = Object.keys(obj.field);
	if (pLinkItemActivity === AllLinkRollUp && filterSelection?.allLinkRollUp?.filterSelection) {
		return { [`${filterSelection?.allLinkRollUp?.filterSelection}`]: `${obj.field[key]}` };
	}
	if (
		pLinkItemActivity === AllLinkRollDetails &&
		filterSelection?.allLinkRollDetails?.filterSelection
	) {
		return { [`${filterSelection?.allLinkRollDetails?.filterSelection}`]: `${obj.field[key]}` };
	}

	if (SSIAllLinkRollupFolders.includes(obj.folderName)) {
		const newKey = Object.keys(obj.field)[0];
		return {
			[`${SSIAllLinkRollupViewName}.${obj.technicalName}`]: obj.field[newKey]
		};
	}
	return {};
};

const updateFieldKey = (oldObject, pKey, isMultiWeek = false, pLinkItemActivity = '') => {
	const oldKey = Object.keys(oldObject.field);
	const newKey = Object.keys(oldObject.field).toString().split('.');

	const validItem =
		SSIAllLinkRollupFolders.includes(oldObject.folderName) ||
		oldObject.technicalName === WM_ITEM_NUMBER_FIELD;

	if (validItem && pLinkItemActivity !== '' && pLinkItemActivity !== null) {
		return getFilterForAllLinkActivity(oldObject, pLinkItemActivity);
	}

	if (isMultiWeek) {
		if (oldObject.dbtechnicalNameMultiTime) {
			return { [`${pKey}.${oldObject.dbtechnicalNameMultiTime}`]: `${oldObject.field[oldKey]}` };
		}
		return { [`${pKey}.${newKey[1]}`]: `${oldObject.field[oldKey]}` };
	}
	if (oldObject.businessName === WEEK_KEY) {
		if (oldObject.filter.condition === CUSTOM) {
			/**
			 * Need to add 1 day in end date manually otherwise looker will miss the last day or week.
			 */
			const newEndDt = moment(oldObject.filter.value[1]).clone().add(1, dayL).format('YYYY/MM/DD');
			return {
				[`${pKey}.${newKey[1]}`]: `${oldObject.filter.value[0]} to ${newEndDt}`
			};
		} else {
			return oldObject.field;
		}
	}

	return { [`${pKey}.${newKey[1]}`]: `${oldObject.field[oldKey]}` };
};

const updateFieldKeyDaily = (
	oldObject,
	pKey,
	isSSI,
	isMultiWeek = false,
	pLinkItemActivity = '',
	isDaily = false
) => {
	const isGregorian = oldObject?.parent === GREGORIAN_CALENDAR;
	const dateWeekMonthQuarterYear = [DATE_KEY, WEEK_KEY, MONTH_KEY, QUARTER_KEY, YEAR_KEY];
	const isDailyAndDate = isDaily && dateWeekMonthQuarterYear.includes(oldObject.businessName);
	const oldKey = Object.keys(oldObject.field);
	const newKey = Object.keys(oldObject.field).toString().split('.');

	const validItem =
		SSIAllLinkRollupFolders.includes(oldObject.folderName) ||
		oldObject.technicalName === WM_ITEM_NUMBER_FIELD;

	if (validItem && pLinkItemActivity !== '' && pLinkItemActivity !== null) {
		return getFilterForAllLinkActivity(oldObject, pLinkItemActivity);
	}

	if (isMultiWeek) {
		return { [`${pKey}.${newKey[1]}`]: `${oldObject.field[oldKey]}` };
	}
	if (oldObject.businessName === WEEK_KEY) {
		if (oldObject.filter.condition === CUSTOM) {
			/**
			 * Need to add 1 day in end date manually otherwise looker will miss the last day or week.
			 */
			const newEndDt = moment(oldObject.filter.value[1]).clone().add(1, dayL).format('YYYY/MM/DD');
			let fieldName = isDaily ? BUSINESS_DATE : newKey[1];
			if (isGregorian) {
				fieldName = oldObject?.businessName === DATE_KEY ? BUSINESS_DATE : GREGORIAN_CALENDAR_WEEK;
				// For SSI, always Greg. calendar selections we need to use business date as fieldName
				if (isSSI) {
					fieldName = BUSINESS_DATE;
				}
			}
			return {
				[`${pKey}.${fieldName}`]: `${oldObject.filter.value[0]} to ${newEndDt}`
			};
		} else {
			if (isDaily) {
				let fieldName = isDaily ? BUSINESS_DATE : newKey[1];
				if (isGregorian) {
					fieldName =
						oldObject?.businessName === DATE_KEY ? BUSINESS_DATE : GREGORIAN_CALENDAR_WEEK;
					// For SSI, always Greg. calendar selections we need to use business date as fieldName
					if (isSSI) {
						fieldName = BUSINESS_DATE;
					}
				}
				return {
					[`${pKey}.${fieldName}`]: `${oldObject.field[oldKey]}`
				};
			}
			return oldObject.field;
		}
	}
	const shouldUseBusinessDate = isDailyAndDate && oldObject.dataType === DATE_KEY_LOWERCASE;
	let fieldName = shouldUseBusinessDate ? BUSINESS_DATE : newKey[1];
	if (isGregorian) {
		fieldName = oldObject?.businessName === DATE_KEY ? BUSINESS_DATE : GREGORIAN_CALENDAR_WEEK;
		// For SSI, always Greg. calendar selections we need to use business date as fieldName
		if (isSSI) {
			fieldName = BUSINESS_DATE;
		}
	}
	return {
		[`${pKey}.${fieldName}`]: `${oldObject.field[oldKey]}`
	};
};

const buildForecastWk = (pSelWeek, pList, pTemplate) => {
	/**
	 * Update WM forecast cal filter, this need to update here because
	 * values will change based on current week or last week selection.
	 * We cannot assume that user will select mandatory time filter first only and then dimension.
	 */
	let forecastWk = {};
	if (pSelWeek && WK_SPEC_TMPT.includes(Number(pTemplate))) {
		const item = pList.find((el) => el.businessName === WM_YR_WK_NO && el.field !== undefined);
		if (item !== undefined) {
			const {
				filter: { condition, value, extraValue }
			} = pSelWeek;
			const oldKey = Object.keys(item.field);
			let retVal = item.field[oldKey];
			let colName = Object.keys(item.field).toString().split('.')[1];
			const { condition: itemCondt, value: itemValue, extraValue: itemExtraValue } = item.filter;
			if (condition !== CUSTOM) {
				let _val = [...itemValue];
				if (itemCondt === CUSTOM) {
					_val = getWKWithYrRange(itemValue, itemExtraValue);
					forecastWk = { [`${item.table}.${PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_WEEK}`]: _val };
					return forecastWk;
				}
				retVal = _val.map((v) => {
					if (condition === FILTER_CONDITION_LABELS.WMT_LAST_WEEK) {
						return v - 1;
					}
					return v;
				});
				retVal = `[${retVal}]`;
			} else {
				/**
				 * | reason to take value[1](and not value[0]) is value[1] contains week end date
				 * | and week end might be end on different month.
				 * | For ex - 202301 => ['2023/01/28', '2023/02/03']
				 */
				if (itemCondt === CUSTOM) {
					const _val = getWKWithYrRange(itemValue, itemExtraValue);
					forecastWk = { [`${item.table}.${PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_WEEK}`]: _val };
					return forecastWk;
				}
				const selMonth = moment(value[1]).month();
				const offset = selMonth === 0 ? 1 : 0;
				const selYear = moment(value[1]).year() - offset;
				const wkCount = item.filter.value[1];
				const minWk = `${selYear}${format2Digit.format(extraValue[0])}`;
				retVal = printWeekDays(selMonth, selYear, minWk, wkCount);
				colName = PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_WEEK;
			}

			forecastWk = { [`${item.tableWeekly}.${colName}`]: retVal };
		}
	}

	return forecastWk;
};

const buildCustomAttrList = (pList, pSelectedList) => {
	const customAttrList = pSelectedList?.filter((item) => item.parent === PARENT_CUST_ATTR);
	let customAttrCounter = 0;
	const customAttrFilterList = customAttrList.map((el) => {
		const prevTbl = el.prevTbl ? el.prevTbl : el.table;
		let ret = {
			[`${prevTbl}${++customAttrCounter}.${CUSTOM_ATTRIBUTE_NAME}`]: `${el.businessName}`
		};

		/**
		 * Iteration over filter list, if filter business name is equal to selectedlist business name then add with 'customAttrCounter'
		 * and custom_attribute_name
		 */
		const o1 = pList.filter(
			(item) => item.businessName === el.businessName && item.field !== undefined
		);
		if (o1.length > 0) {
			const o2 = o1[0];
			const oldKey = Object.keys(o2.field);
			ret = {
				...ret,
				[`${prevTbl}${customAttrCounter}.${CUSTOM_ATTRIBUTE_VALUE}`]: `${o2.field[oldKey]}`
			};
		}

		return ret;
	});

	/**
	 * Iterate filterlist for custom attribute, if businessName already present in customAttrFilterList then move to next item
	 * If businessName is not matching to filterlist and customAttrFilterList then add custom_attribute_name and custom_attribute_value with
	 * customAttrCounter
	 */

	const restFilterList = [];
	pList.forEach((el) => {
		if (el.parent === PARENT_CUST_ATTR && el.field !== undefined) {
			const custAttrCovered = customAttrFilterList.find((o) => {
				for (const key in o) {
					if (o[key] === el.businessName) {
						return el;
					}
				}
			});
			if (!custAttrCovered) {
				const oldKey = Object.keys(el.field);
				restFilterList.push({
					[`${el.table}${++customAttrCounter}.${CUSTOM_ATTRIBUTE_NAME}`]: `${el.businessName}`,
					[`${el.table}${customAttrCounter}.${CUSTOM_ATTRIBUTE_VALUE}`]: `${el.field[oldKey]}`
				});
			}
		}
	});

	return [...customAttrFilterList, ...restFilterList];
};

const getAttributes = (
	pSelList,
	pFilterList,
	pSelTmpl,
	pTmplData,
	pLinkItemActivity,
	isGregorian
) => {
	const isSSITemplate = STR_TMPT_LIST.includes(Number(pSelTmpl));
	const isAllLinkItem = ALL_LINK_ITEM_LIST.includes(Number(pSelTmpl));

	let list = [];
	/**
	 * If canned report is selected then add first field in payload for vendor_nbr
	 */
	if (CANNED_REPORT_LIST.includes(Number(pSelTmpl))) {
		pSelList.map((item) => item.technicalNameList.map((tn) => list.push(`${item.table}.${tn}`)));
		pTmplData[0].dimensions.forEach((dim) => {
			if (dim.technicalName === VENDOR_NBR || dim.technicalName === VENDOR_NM) {
				const vendorField = `${dim.table}.${dim.dbtechnicalName}`;
				list.unshift(vendorField);
			}
		});
	} else {
		let customAttrCounter = 0;
		const isDCMetrics = DC_TMPT_LIST.includes(Number(pSelTmpl));
		const isMultiWeek = pFilterList?.find(
			(el) => isMultiWeekSel(el, Number(pSelTmpl)) || isMTS(el)
		);
		let isWeekSel = pFilterList?.find((el) => el.businessName === WEEK_KEY);
		const isRegSales = REGISTER_SALES_LIST.includes(Number(pSelTmpl));
		if (isSSITemplate || isDCMetrics || isRegSales) {
			isWeekSel = !isSSIAndDCDaily(pSelList, pFilterList);
		}
		if (isGregorian) {
			isWeekSel = false;
		}
		const isDateColSelected = pSelList.some(
			(selectedColumn) => selectedColumn.businessName === DATE_KEY
		);
		list = pSelList.map((item) => {
			/**
			 * For SSI template allLinkRollUp selection,
			 * the View name should changed to 'vw_chnl_perf_item_roll_up' for all "dimensions" attributes under specific folders
			 * Exception, attribute - "item_access_type"
			 */
			const isAttributeUnderFolder =
				item?.parent === ATTRIBS_LOWERCASE.dimensions &&
				item?.technicalName !== 'item_access_type' &&
				SSIAllLinkRollupFolders.includes(item?.folderName);
			const shouldUpdateViewName =
				isAllLinkItem && pLinkItemActivity === AllLinkRollUp && isAttributeUnderFolder;

			if (item.parent === PARENT_CUST_ATTR) {
				const prevTbl = item.prevTbl ? item.prevTbl : item.table;
				return `${prevTbl}${++customAttrCounter}.${item.technicalName}`;
			}
			if (isMultiWeek) {
				const multiWeekTable = item.tableWeeklyMultiWindow
					? item.tableWeeklyMultiWindow
					: isMultiWeek.tableWeeklyMultiWindow;

				if (isCalFamily(item)) {
					return `${multiWeekTable}.wm_time_window_week`;
				}

				/**
				 * For Basic users, if MTS has been selected then if available we need to use technicalNameMultiTime instead of technicalName
				 */
				const colName = item.technicalNameMultiTime || item.technicalName;
				if (shouldUpdateViewName) {
					return `${SSIAllLinkRollupViewName}.${colName.trim()}`;
				}
				return `${multiWeekTable}.${colName.trim()}`;
			}
			if (isWeekSel) {
				if (shouldUpdateViewName) {
					return `${SSIAllLinkRollupViewName}.${item.technicalName.trim()}`;
				}
				if (WK_SPEC_TMPT.includes(Number(pSelTmpl))) {
					return `${item.tableWeekly}.${item.technicalName.trim()}`;
				}
			}

			if (shouldUpdateViewName) {
				return `${SSIAllLinkRollupViewName}.${item.technicalName.trim()}`;
			}
			// if it is SSI & Supplier & daily is selected as a column, then all the fields should have dly instead of wkly
			// that is why it is hardcoded in that specific case
			let itemTable = item.table;
			if ((isSSITemplate || isRegSales) && isDateColSelected) {
				itemTable = itemTable.replaceAll('wkly', 'dly');
			}
			return `${itemTable}.${item.technicalName}`;
		});
	}

	// For SSI template - If the user has selected All Link roll up and the list of attributes include
	// unit cost amount, then it must be removed as per requirements.
	const filteredList = list.filter((item) => {
		return !(
			isAllLinkItem &&
			pLinkItemActivity === AllLinkRollUp &&
			['manufacturing_company_id', 'unit_cost_amount'].includes(item)
		);
	});
	return filteredList;
};

const getDefaultFilter = (
	pSelList,
	pFilterList,
	pPersona,
	pSelTmpl,
	pSelTmplData,
	custType,
	isMTSFilterSelected,
	isGregorian = false
) => {
	const { SUPPLIER, BASIC_VENDOR, MERCHANT } = PERSONA;
	/**
	 * CASE 1: In case of catman : flag =Y based on daily or weekly selection.
	 * CASE 2:In case of merchant :
	 * a). if parent company name (Dimension) is  selected or in filter : no need to send
	 * b). if parent company name is not selected or in filter : flag = y
	 * CASE 3: In case of supplier : no need to send.
	 */
	const persona = getPersona(pPersona, custType);

	/* CASE 3 */
	if ([SUPPLIER, BASIC_VENDOR].includes(persona)) {
		return {};
	}

	/* CASE 2(a) */
	if (persona === MERCHANT) {
		const l1 = pSelList.some((el) => el.businessName === 'Parent Company Name');
		const l2 = pFilterList.some(
			(el) => el.businessName === 'Parent Company Name' && el.field !== undefined
		);
		if (l1 || l2) {
			return {};
		}
	}

	const o = pSelTmplData[0]?.defaultFilters;
	/** it means no default filter available in api response*/
	if (o === undefined) {
		return {};
	}
	/* CASE 2{b} and case 1 */
	let obj = Object.assign({}, ...o.daily);

	if (isGregorian) {
		return !obj ? {} : obj;
	}

	const isSSI = STR_TMPT_LIST.includes(Number(pSelTmpl));
	const isDCMetrics = DC_TMPT_LIST.includes(Number(pSelTmpl));
	const isRegSales = REGISTER_SALES_LIST.includes(Number(pSelTmpl));
	let isWeekSel = pFilterList?.some((el) => el.businessName === WEEK_KEY);
	const isMultiWeek =
		isMTSFilterSelected || pFilterList?.some((el) => isMultiWeekSel(el, Number(pSelTmpl)));
	if (isSSI || isDCMetrics || isRegSales) {
		isWeekSel = !isSSIAndDCDaily(pSelList, pFilterList);
	}

	if (isMultiWeek) {
		obj = Object.assign({}, ...o.weeklyMultiWindow);
	} else if (WK_SPEC_TMPT.includes(Number(pSelTmpl)) && isWeekSel) {
		obj = Object.assign({}, ...o.weekly);
	}

	/** Just to handle exception and to avoid to break app */
	if (!obj) {
		return {};
	}

	return obj;
};

const getSortedAttributes = (
	pSelList,
	attributes,
	pIsMultiWeek,
	pSelectedTemplate,
	is104WeeksFilterApplied = false
) => {
	let copyOfAttr = deepClone(attributes);
	if (pIsMultiWeek) {
		copyOfAttr = copyOfAttr.filter(
			(at) =>
				pSelList.filter((sel) => at.indexOf(sel.technicalName) > -1)[0]?.parent !==
				ATTRIBS_LOWERCASE.measures
		);
		const multiTimeAttr = copyOfAttr.splice(0, 1);
		copyOfAttr.push(multiTimeAttr[0]);
		return copyOfAttr;
	}
	/** The Vendor blocks should be sorted by Omni Sales in dollars */
	if (CANNED_REPORT_LIST.includes(Number(pSelectedTemplate))) {
		/** If Omni Sales in dollars related metrics are not selected then we should not to pass the first field for sort as normal templates */
		const omniDollarSales = pSelList.find(
			(item) => item.technicalName === 'auth_based_net_sales_amt'
		);
		if (omniDollarSales) {
			const sort = `${omniDollarSales.table}.${omniDollarSales.technicalNameList[0]} desc`;
			return [sort];
		}
	}

	if (is104WeeksFilterApplied) {
		// The sorting attribute should append the 'desc' string, if user has 104 Weeks filter applied
		return [`${copyOfAttr[0]} desc`];
	}

	return [copyOfAttr[0]];
};

const isMTSAppliedRowWise = (list, selectedTemp) => {
	const originalMTSValues = [
		'1300-01-01',
		'1400-01-01',
		'1500-01-01',
		'1600-01-01',
		'1700-01-01',
		'1800-01-01'
	];
	let multiWeekIndex = -1;
	const filter = list.find((el, index) => {
		if (
			isMultiWeekSel(el, Number(selectedTemp)) &&
			originalMTSValues.includes(el.filter.value[0])
		) {
			multiWeekIndex = index;
			return el;
		}
	});
	return { multiWeek: filter, index: multiWeekIndex };
};

const convertRowToColMTS = (
	data,
	selectedList,
	multiWeek,
	// templateData,
	tmpData,
	templateId,
	dispatchSelectedList,
	parentName
) => {
	/** Remove week from columns */
	/** Prepare selected list based on columns */

	/** Update filters with value */
	const list = data.filtersWithValue;
	const index = multiWeek.index;

	const filter = list[index];
	const dateFormat = 'MM/DD/YYYY';
	const maxWeekDuration = filter.filter.condition
		.split(',')
		.map((range) => getRequestedNoOfWeeks(range))
		.reduce((a, b) => Math.max(a, b), 0);

	const maxWeekRangeCond = getConditionFieldFromWeek(maxWeekDuration);
	const lValue = getDateRange(maxWeekRangeCond);
	const dValue = getDateRange(maxWeekRangeCond, true);
	filter.filter.value = lValue;
	filter.filter.extraValue = [
		moment(dValue[0]._d).format(dateFormat),
		moment(dValue[1]._d).format(dateFormat)
	];
	filter.field = build(filter, data.runQueryRequestObject.view, '', false);
	list[index] = filter;
	data.filtersWithValue = list;

	/** Update runQueryRequestObject */
	data.runQueryRequestObject = getRequestBody({
		isPreview: true,
		filterList: data.filtersWithValue,
		selectedTemplate: templateId,
		selectedList,
		parentName,
		selectedView: data.runQueryRequestObject.view,
		dispatchSelectedList,
		persona: data.reportType,
		selectedTmplData: tmpData,
		linkItemActivity: data.linkItemActivity
	});

	return data;
};

/**
 * if date column ir selected or if "yesterday", "last weekend" or "custom" are selected, then it is daily
 * @param {*} selectedList columns selected
 * @param {*} filterList filter applied
 * @returns true if it is daily, otherwise false
 */
export const isSSIAndDCDaily = (selectedList, filterList) => {
	const dateColumnSelected = selectedList.some(
		(selectedColumn) => selectedColumn.businessName === DATE_KEY
	);
	if (dateColumnSelected) {
		return true;
	}
	const dateFilterSelected = filterList.some((selectedFilter) => {
		return selectedFilter.businessName === DATE_KEY;
	});
	return dateFilterSelected;
};

const getFuzzyOption = (filterCondition, filterBusinessName) => {
	let result = '';
	if (filterBusinessName === YEAR_KEY) {
		if (filterCondition.includes(YEAR_TO_DATE_KEY)) {
			result = FUZZY_OPTIONS[YEAR_TO_DATE_KEY];
		} else {
			result = FUZZY_OPTIONS[YEAR_KEY];
		}
	} else {
		const fuzzyKeys = Object.keys(FUZZY_OPTIONS);
		for (const key of fuzzyKeys) {
			if (filterCondition === key || filterCondition.endsWith(key)) {
				result = FUZZY_OPTIONS[key];
				break;
			}
		}
	}
	return result;
};

const getFuzzyOptions = (mtsFilters, calendar) => {
	const filters = deepClone(mtsFilters);
	delete filters?.CUSTOM_DATE_1;
	delete filters?.CUSTOM_DATE_2;

	const fuzzyStringOptions = Object.values(filters ?? {});
	return fuzzyStringOptions.map((option) => {
		return {
			fuzzy: getFuzzyOption(option),
			calendar: calendar
		};
	});
};

/**
 * Updates response json from quick report call to have dates fetched from calendarRollDim call.
 * @param {Object} responseJson response of a quick report call
 * @param {Array<Object>} calendarRollDim dates fetched from calendarRollDim call
 * @returns modified response json where dates are updated from calendarRollDim
 */
const getUpdatedSubTemplateDetails = (responseJson, calendarRollDim) => {
	// DSIDVL-42765: When the user clicks on a quick report, a call is made to BE to fetch the payload
	// required for that quick report. The extraValue field from filtersWithValue for fuzzy options (Eg: "Yesterday")
	// should not be considered and we are making an extra call for it on page load called calendarRollDim.
	// The value from the calendarRollDim call should overwrite extraValue in this call.

	// Check whether the current call has any Fuzzy option filters (Eg: "Yesterday").
	const fuzzyOptionsKeys = Object.keys(FUZZY_OPTIONS);
	const hasFuzzyOptionFilter = responseJson?.filtersWithValue?.find((item) => {
		return fuzzyOptionsKeys.some(
			(fuzzyOptionKey) => fuzzyOptionKey === item?.filter?.condition?.trim()
		);
	});
	// If our current call does have a filter with one of the fuzzy options and that filter has extraValue
	if (hasFuzzyOptionFilter && hasFuzzyOptionFilter?.filter?.extraValue?.length > 0) {
		// Get the correct dates from the other call "calendarRollDim"
		const latestDates = calendarRollDim?.find((calItem) => {
			return (
				calItem?.timeframe === FUZZY_OPTIONS[hasFuzzyOptionFilter?.filter?.condition?.trim()] &&
				calItem?.calendarType === FUZZY_CALENDAR[hasFuzzyOptionFilter?.parent]
			);
		});
		// If the dates exist in redux
		if (latestDates?.weekStartDate && latestDates?.weekEndDate) {
			// Parse the dates so that they match the current format
			const newExtraValues = [
				moment(latestDates.weekStartDate).format('MM/DD/YYYY'),
				moment(latestDates.weekEndDate).format('MM/DD/YYYY')
			];
			// Update the current response json to overwrite the value for extraValue for the fuzzy filter.
			return {
				...responseJson,
				filtersWithValue: responseJson?.filtersWithValue.map((item) => {
					if (
						fuzzyOptionsKeys.some(
							(fuzzyOptionKey) => fuzzyOptionKey === item?.filter?.condition?.trim()
						)
					) {
						return {
							...item,
							filter: {
								...item?.filter,
								extraValue: newExtraValues
							}
						};
					}
					return item;
				})
			};
		}
	}
	// If there are no fuzzy options in the current call, return the original response json
	return responseJson;
};

const getRequestBody = (props) => {
	const {
		isPreview = false,
		filterList,
		selectedTemplate,
		selectedList,
		selectedView,
		dispatchSelectedList,
		parentName,
		persona,
		selectedTmplData,
		linkItemActivity = '',
		customerType,
		// userDetails
		itemShare,
		customDatasetDetails = {}
	} = props;

	const mtsFilterSelected = filterList?.find((filter) => isMTS(filter));
	const isMTSFilterSelected = Boolean(mtsFilterSelected);
	const isGregorian = filterList?.some((filter) => filter?.parent === GREGORIAN_CALENDAR);
	const attributes = getAttributes(
		selectedList,
		filterList,
		selectedTemplate,
		selectedTmplData,
		linkItemActivity,
		isGregorian
	);

	const defaultFilters = getDefaultFilter(
		selectedList,
		filterList,
		persona,
		selectedTemplate,
		selectedTmplData,
		customerType,
		isMTSFilterSelected,
		isGregorian
	);
	// TODO: since fuzzy options is a POC only for SSI & supplier, this needs to be updated whenever it is applied to all templates.
	const isCustomDS = isCustomDataset(selectedTemplate);
	const isRegSales = REGISTER_SALES_LIST.includes(Number(selectedTemplate));
	const isTemplateRequireFieldUpdate =
		STR_TMPT_LIST.includes(Number(selectedTemplate)) || isCustomDS || isRegSales;
	const isDCMetrics = DC_TMPT_LIST.includes(Number(selectedTemplate));

	let usrFilterList = [];
	let isMultiWeek = filterList?.find((el) => isMultiWeekSel(el, Number(selectedTemplate)));
	if (isMTSFilterSelected) {
		isMultiWeek = mtsFilterSelected;
	}
	let isWeekSel = filterList?.find((el) => el.businessName === WEEK_KEY);
	if (isTemplateRequireFieldUpdate || isDCMetrics) {
		isWeekSel = !isSSIAndDCDaily(selectedList, filterList);
	}
	if (isGregorian) {
		isWeekSel = false;
	}

	/***
	 * | We're eliminating below fields because
	 * | field !== undefined =>remove all those object which doesn't get applied.
	 * | parent !== PARENT_CUST_ATTR => there is separate func to build cust attr.
	 * | businessName === WM_YR_WK_NO => there is separate func to build forecast attr.
	 * */
	const list = filterList.filter(
		(f) => f.field !== undefined && f.parent !== PARENT_CUST_ATTR && f.businessName !== WM_YR_WK_NO
	);

	// TODO (DSIDVL-41996): this will result in a sonar lint since updateFieldKey function is being used in a similar way
	// in two places but resolving it immediately is causing bugs as it messes up with the flow of execution
	if (isTemplateRequireFieldUpdate && isWeekSel && !isMultiWeek) {
		usrFilterList = list?.map((el) =>
			updateFieldKey(el, el.tableWeekly, isMultiWeek, linkItemActivity)
		);
	} else if (isTemplateRequireFieldUpdate && !isWeekSel && !isMultiWeek) {
		usrFilterList = list?.map((el) =>
			updateFieldKeyDaily(
				el,
				el.table.replaceAll('wkly', 'dly'),
				isTemplateRequireFieldUpdate,
				isMultiWeek,
				linkItemActivity,
				true
			)
		);
	} else if (isMultiWeek) {
		const tableName = isMultiWeek.tableWeeklyMultiWindow;
		usrFilterList = list?.map((el) =>
			updateFieldKey(
				el,
				el.tableWeeklyMultiWindow ? el.tableWeeklyMultiWindow : tableName,
				isMultiWeek,
				linkItemActivity
			)
		);
	} else if (WK_SPEC_TMPT.includes(Number(selectedTemplate)) && isWeekSel) {
		usrFilterList = list?.map((el) =>
			updateFieldKey(el, el.tableWeekly, isMultiWeek, linkItemActivity)
		);
	} else {
		usrFilterList = list?.map((item) => item.field);
	}

	const customAttrList = buildCustomAttrList(filterList, selectedList);

	let usrFilterObj = Object.assign({}, ...usrFilterList, ...customAttrList);

	/** Below selectedList need to update as below. This will help in column mapping in preview table. */
	let custAttrInd = 0;
	const l1 = selectedList.map((item) => {
		if (item.parent !== PARENT_CUST_ATTR) {
			return item;
		}
		const prevTbl = item.prevTbl ? item.prevTbl : item.table;
		return {
			...item,
			prevTbl: prevTbl,
			table: `${prevTbl}${++custAttrInd}`
		};
	});

	dispatchSelectedList(l1);
	if (isPreview) {
		const shrinkObj = buildShrinkTimeWindow(
			filterList,
			selectedTemplate,
			selectedView,
			selectedTmplData,
			selectedList,
			linkItemActivity,
			isGregorian
		);
		const formattedObj = Object.assign({}, ...customAttrList);
		usrFilterObj = { ...formattedObj, ...shrinkObj };
	} else {
		// DSIDVL-36891: replace "business_date" with "report_date" if it is ecomm inventory
		// This already happens in buildShrinkTimeWindow which is why it is not required for preview.
		if (
			ECOM_INVENTORY.includes(Number(selectedTemplate)) ||
			ECOMM_INSTOCK_LIST.includes(Number(selectedTemplate))
		) {
			const transformedFilters = Object.entries(usrFilterObj).map(([key, value]) => {
				const updatedKey = key.replace(BUSINESS_DATE, REPORT_DATE);
				return [updatedKey, value];
			});
			usrFilterObj = Object.fromEntries(transformedFilters);
		}
	}

	// Check if Trait number is selected and has "all of" selected and if yes, then add one more key-value pair
	let traitNumberWithHasAll = {};
	const hasTraitNumberAllOf = filterList?.some(
		(item) => item?.businessName === TRAIT_NUMBER && item?.filter?.condition === HAS_ALL_OF
	);

	if (hasTraitNumberAllOf) {
		let traitNumberKey = '';
		const traitNumberObj = usrFilterList?.find((current) => {
			const keys = Object.keys(current);
			const traitObj = keys?.find((key) => {
				const isTraitNumber = key?.split('.')?.[1] === TRAIT_NBR;
				if (isTraitNumber) {
					traitNumberKey = key;
				}
				return isTraitNumber;
			});
			return traitObj;
		});
		let hasAllValue = traitNumberObj?.[traitNumberKey] ?? '';
		const traitNumberHasAllKey = traitNumberKey.replace('nbr', 'number');
		if (hasAllValue) {
			hasAllValue = hasAllValue
				?.split(',')
				?.map((val) => Number(val))
				?.sort((a, b) => b - a)
				?.join('^,');
		}
		traitNumberWithHasAll = {
			[traitNumberHasAllKey]: hasAllValue
		};
		usrFilterObj = { ...usrFilterObj, ...traitNumberWithHasAll };
	}

	if (ALL_LINK_ITEM_LIST.includes(Number(selectedTemplate))) {
		// For SSI template, allLinkRollUp selection if the filter attribute is walmart_item_number,
		// then update the second parts of the key 'walmart_item_number' to => 'wm_nbr'
		if (linkItemActivity === AllLinkRollUp) {
			for (const key in usrFilterObj) {
				if (key.includes(WM_ITEM_NUMBER_FIELD)) {
					const value = usrFilterObj[key];
					const newKey = `${SSIAllLinkRollupViewName}.wm_nbr`;
					usrFilterObj[newKey] = value;
					// deletes the old key
					delete usrFilterObj[key];
				}
			}
		}
		// For All links details selection,
		// if the filter field is walmart_item_number then table name should be changed to "vw_chnl_perf_item_roll_details"
		if (linkItemActivity === AllLinkRollDetails) {
			for (const key in usrFilterObj) {
				if (key.includes(WM_ITEM_NUMBER_FIELD)) {
					const value = usrFilterObj[key];
					const newKey = `${SSIAllLinkDetailsViewName}.${WM_ITEM_NUMBER_FIELD}`;
					usrFilterObj[newKey] = value;
					if (key !== newKey) {
						// deletes the old key
						delete usrFilterObj[key];
					}
				}
			}
		}
	}

	const forecastWk = buildForecastWk(isWeekSel, filterList, selectedTemplate);

	const isBasic = customerType === BASIC;

	const filterExpression = () => {
		let filter = selectedTmplData?.[0]?.filter;
		let filterWeekly = selectedTmplData?.[0]?.filterWeekly;
		let filterWeeklyMultiWindow = selectedTmplData?.[0]?.filterWeeklyMultiWindow;
		if (isCustomDS && Object.values(customDatasetDetails).length > 0) {
			filter = customDatasetDetails?.filter;
			filterWeekly = customDatasetDetails?.filterWeekly;
			filterWeeklyMultiWindow = customDatasetDetails?.filterWeeklyMultiWindow;
		}
		let keyName = filter;
		if (isMultiWeek) {
			keyName = filterWeeklyMultiWindow;
		} else if (isWeekSel) {
			keyName = filterWeekly || filter; // tmplts like omni and ecom inv filterweekly will be undefined. hence, take filter.
		}

		return customerType === BASIC ? { [keyName]: PERSONA.BASIC_CATMAN } : {};
	};

	const parentFilter = isBasic ? filterExpression() : parentName;
	const getModel = () => {
		if (isBasic) {
			return 'dvcperf_report_builder_basic';
		} else {
			return persona === PERSONA.MERCHANT
				? 'dvcperf_report_builder_merchant'
				: 'dvcperf_report_builder';
		}
	};

	let updatedFilters = { ...parentFilter, ...usrFilterObj, ...forecastWk, ...defaultFilters };

	const timeSelection = {};
	const isFuzzy = FUZZY_TMPT_LIST.includes(Number(selectedTemplate));
	const isCanned = SHOW_AS_CANNED_REPORT.includes(Number(selectedTemplate));
	if ((isFuzzy && !isMultiWeek) || isMultiWeek || isCustomDS || isCanned) {
		// Building the timeSelection object for fuzzy options
		// 1. Columns selected ['date', 'week', 'month', 'quarter', 'year']
		const columnSelection = [];
		selectedList.forEach((selectedColumn) => {
			if (selectedColumn.businessName === DATE_KEY) {
				if (!columnSelection.includes(dateL)) {
					columnSelection.push(dateL);
				}
			} else if (selectedColumn.businessName === WEEK_KEY) {
				if (!columnSelection.includes(weekL)) {
					columnSelection.push(weekL);
				}
			} else if (selectedColumn.businessName === MONTH_KEY) {
				if (!columnSelection.includes(monthL)) {
					columnSelection.push(monthL);
				}
			} else if (selectedColumn.businessName === QUARTER_KEY) {
				if (!columnSelection.includes(quarterL)) {
					columnSelection.push(quarterL);
				}
			} else if (selectedColumn.businessName === YEAR_KEY) {
				if (!columnSelection.includes(yearL)) {
					columnSelection.push(yearL);
				}
			}
		});
		timeSelection.columnSelection = columnSelection;
		// Make sure custom and selection have these initial values cos for custom datasets, we might not have any time filters applied
		timeSelection.custom = {};
		timeSelection.selection = [];

		// Building "custom" and "selection". Usually, if its a fuzzy option then selection is populated
		// if it is a custom date filter, then custom is populated.
		const weekMonthQuarterYear = [WEEK_KEY, MONTH_KEY, QUARTER_KEY, YEAR_KEY];
		const dateFilter = filterList.find((filterItem) => filterItem.businessName === DATE_KEY);
		const otherFilter = filterList.find((filterItem) =>
			weekMonthQuarterYear.includes(filterItem.businessName)
		);
		const filterKeys = Object.keys(updatedFilters);

		if (
			!isPreview &&
			[...TENDER_ANALYSIS_LIST, ...SHIP_TO_ZIP_LIST].includes(Number(selectedTemplate))
		) {
			const tableName = getTableName(selectedView);
			let oldKeyName = '';
			let newKeyName = '';
			filterKeys.forEach((key) => {
				if (
					CANNED_REPORT_TIME_OPTIONS.some((option) => key.includes(option)) ||
					key.includes(BUSINESS_DATE)
				) {
					newKeyName = TENDER_ANALYSIS_LIST.includes(Number(selectedTemplate))
						? `${tableName}.${VISIT_LOCAL_DATE}`
						: `${tableName}.${BUSINESS_DATE}`;
					oldKeyName = key;
					const tempFilterObj = updatedFilters[key];
					delete updatedFilters[key];
					updatedFilters[newKeyName] = tempFilterObj;
				}
			});
			if (oldKeyName !== '') {
				filterKeys.splice(filterKeys.indexOf(oldKeyName));
				filterKeys.push(newKeyName);
			}
		}

		if (dateFilter) {
			// If it is SSI, then we look for Business date, if it is DC metrics, we look for inventory date
			// If it is TA, we look for visit_local_date
			const dateFilterKey = filterKeys.find(
				(key) =>
					key.includes(BUSINESS_DATE) ||
					key.includes(INVENTORY_DATE) ||
					key.includes(MUMD_DATE) ||
					key.includes(REPORT_DATE) ||
					key.includes(VISIT_LOCAL_DATE)
			);
			if (dateFilter?.filter.condition === CUSTOM) {
				const dateValues = updatedFilters[dateFilterKey]?.split(' ');
				timeSelection.custom = {
					date: [[dateValues[0].replaceAll('/', '-'), dateValues[2].replaceAll('/', '-')]]
				};
				timeSelection.selection = [];
			} else {
				timeSelection.custom = {};
				timeSelection.selection = [
					{
						fuzzy: getFuzzyOption(dateFilter.filter.condition, dateFilter.businessName),
						calendar: FUZZY_CALENDAR[dateFilter.parent]
					}
				];

				// Updating the filters to the following format: `vw_chnl_perf_store_invt_sales_dly.business_date: "1100/01/01 to 1200/01/01"`
				if (!isPreview) {
					const dailyFilter = selectedList?.find(
						(item) => item.businessName === DATE_KEY && item.dataType === dateL
					);
					let businessDateKey = BUSINESS_DATE;
					if (dailyFilter) {
						// DSIDVL-42987: For DC metrics, its inventory date.
						businessDateKey = `${dailyFilter.table}.${
							isDCMetrics ? INVENTORY_DATE : BUSINESS_DATE
						}`;
					}
					filterKeys.forEach((key) => {
						// DSIDVL-38299: If the user selects "Yesterday" from Gregorian - Date, then don't replace the value
						if (
							key.includes(businessDateKey) ||
							key.includes(WALMART_WEEK_START_DATE) ||
							key.includes(GREGORIAN_CALENDAR_WEEK) ||
							key.includes(VISIT_LOCAL_DATE) ||
							key.includes(REPORT_DATE) ||
							(key.includes(CAL_ROLL_DAY) && !isGregorian)
						) {
							updatedFilters[key] = FUZZY_DATE_VALUE;
						}
					});
				}
			}
		}
		// otherFilter - could be week, month, quarter or year
		if (otherFilter) {
			if (otherFilter?.filter.condition === CUSTOM) {
				const weekFilterKey = filterKeys.find(
					(key) =>
						key.includes(WALMART_WEEK_START_DATE) ||
						key.includes(BUSINESS_DATE) ||
						key.includes(REPORT_DATE) ||
						key.includes(INVENTORY_DATE) ||
						key.includes(CAL_ROLL_DAY) ||
						key.includes(VISIT_LOCAL_DATE) ||
						key.includes(MUMD_DATE)
				);
				const dateValues = updatedFilters[weekFilterKey]?.split(' ');
				timeSelection.custom = {
					week: [[dateValues[0].replaceAll('/', '-'), dateValues[2].replaceAll('/', '-')]]
				};
				timeSelection.selection = [];
			} else {
				timeSelection.custom = {};
				const filterConditions = otherFilter.filter?.condition?.split(',');
				timeSelection.selection = [];
				const fuzzyOptions = filterConditions.map((filterCondition) => {
					return {
						fuzzy: getFuzzyOption(filterCondition, otherFilter.businessName),
						calendar: FUZZY_CALENDAR[otherFilter.parent]
					};
				});
				timeSelection.selection = fuzzyOptions;

				// Updating the filters to the following format: `vw_chnl_perf_store_invt_sales_dly.business_date: "1100/01/01 to 1200/01/01"`
				if (!isPreview) {
					const dailyFilter = selectedList?.find(
						(item) => item.businessName === DATE_KEY && item.dataType === dateL
					);
					let businessDateKey = BUSINESS_DATE;
					if (dailyFilter) {
						businessDateKey = `${dailyFilter.table}.${BUSINESS_DATE}`;
					}
					filterKeys.forEach((key) => {
						if (
							key.includes(businessDateKey) ||
							key.includes(WALMART_WEEK_START_DATE) ||
							key.includes(GREGORIAN_CALENDAR_WEEK) ||
							key.includes(VISIT_LOCAL_DATE) ||
							key.includes(REPORT_DATE)
						) {
							updatedFilters[key] = FUZZY_DATE_VALUE;
						}
					});
				}
			}
		}
	}

	const mtsFilter = filterList?.find((filter) => isMTS(filter));
	if (mtsFilter) {
		timeSelection.columnSelection = [];
		const custom = {};
		const customDateOne = mtsFilter?.mts?.CUSTOM_DATE_1;
		const customDateTwo = mtsFilter?.mts?.CUSTOM_DATE_2;
		// Adding 1 day to end date
		const startDate1 = moment(customDateOne?.date?.startDateString).format('YYYY-MM-DD');
		const endDate1 = moment(customDateOne?.date?.endDateString).add(1, dayL).format('YYYY-MM-DD');
		const startDate2 = moment(customDateTwo?.date?.startDateString).format('YYYY-MM-DD');
		const endDate2 = moment(customDateTwo?.date?.endDateString).add('1', dayL).format('YYYY-MM-DD');

		if (customDateOne?.rangeType === dayL) {
			custom.date = [[startDate1, endDate1]];
		} else if (customDateOne?.rangeType === weekL) {
			custom.week = [[startDate1, endDate1]];
		}

		if (customDateTwo?.rangeType === dayL) {
			custom.date = [...(custom?.date ?? []), [startDate2, endDate2]];
		} else if (customDateTwo?.rangeType === weekL) {
			custom.week = [...(custom?.week ?? []), [startDate2, endDate2]];
		}

		timeSelection.custom = custom;
		timeSelection.selection = getFuzzyOptions(mtsFilter?.mts, FUZZY_CALENDAR[mtsFilter.parent]);
	}

	const is104WeeksFilterApplied = determine104WeeksFeatureInFilterList(filterList);
	const sortedAttr = getSortedAttributes(
		selectedList,
		attributes,
		isMultiWeek,
		selectedTemplate,
		is104WeeksFilterApplied
	);

	const result = {
		model: getModel(),
		view: getView(isMultiWeek, isWeekSel, selectedTemplate),
		fields: attributes,
		sorts: sortedAttr,
		filters: updatedFilters,
		limit: '50',
		itemShare
	};
	if (Object.keys(timeSelection).length > 0) {
		result.timeSelection = { ...timeSelection };
	}

	const isFutureValidItem = FUTURE_VALID_LIST.includes(Number(selectedTemplate));
	if (isFutureValidItem && selectedTmplData[0].preSelectedFields?.length > 0) {
		result.fields = [...result.fields, ...selectedTmplData[0].preSelectedFields];
	}

	if (isCustomDS) {
		result.fields = result.fields.map((field) => {
			const fieldSplit = field.split('.');
			if (fieldSplit.length < 2) {
				return field;
			}
			return fieldSplit[1] === CUSTOM_ATTRIBUTE_VALUE ? field : fieldSplit[1];
		});
		result.sorts = result.sorts.map((sortedAttribute) => {
			const sortedAttributeSplit = sortedAttribute.split('.');
			if (sortedAttributeSplit.length < 2) {
				return sortedAttribute;
			}
			return sortedAttributeSplit[1] === CUSTOM_ATTRIBUTE_VALUE
				? sortedAttribute
				: sortedAttributeSplit[1];
		});
		const transformedEntries = Object.entries(result.filters).map(([key, value]) => {
			const filterSplit = key.split('.');
			if (filterSplit.length < 2) {
				return [key, value];
			}
			return [CATMAN_USER_ID, CUSTOM_ATTRIBUTE_NAME, CUSTOM_ATTRIBUTE_VALUE].includes(
				filterSplit[1]
			)
				? [key, value]
				: [filterSplit[1], value];
		});

		result.filters = Object.fromEntries(transformedEntries);
	}
	return result;
};

const buildShrinkTimeWindow = (
	pList,
	pTemplate,
	pView,
	pSelectedTmplData,
	pSelectedList,
	pLinkItemActivity = '',
	isGregorian = false
) => {
	let isWeekSel = pList?.some((el) => el.businessName === WEEK_KEY);
	const isSSITemplate = STR_TMPT_LIST.includes(Number(pTemplate));
	const isDCMetrics = DC_TMPT_LIST.includes(Number(pTemplate));
	const isRegSales = REGISTER_SALES_LIST.includes(Number(pTemplate));
	if (isSSITemplate || isDCMetrics || isRegSales) {
		isWeekSel = !isSSIAndDCDaily(pSelectedList, pList);
	}
	if (isGregorian) {
		isWeekSel = false;
	}
	const isMultiTimeSelection = pList?.find((filter) => isMTSAndNotDefault(filter));
	/***
	 * | We're eliminating below fields because
	 * | field !== undefined =>remove all those object which doesn't get applied.
	 * | parent !== PARENT_CUST_ATTR => there is separate func to build cust attr.
	 * | businessName === WM_YR_WK_NO => there is separate func to build forecast attr.
	 * */
	const list = pList.filter(
		(f) => f.field !== undefined && f.parent !== PARENT_CUST_ATTR && f.businessName !== WM_YR_WK_NO
	);

	const dateFormat = 'YYYY/MM/DD';

	let fieldList = list?.map((item) => {
		if (isCalFamily(item)) {
			/**
			 * If multi time selection has been done then shrink window should only get last week of data
			 */
			if (isMultiWeekSel(item, Number(pTemplate)) || isMTSAndNotDefault(item)) {
				const oldKey = Object.keys(item.field);
				return { [oldKey]: `1300-01-01` };
			}

			//Check for parent folder is exist or not In Purchase order parent folder is marked '' (in cosmos db)
			const isCheckParentFolder = item?.parent === '';

			//If this is purchase order we checking parent is '' or not for walmart calendar we will have value.
			const isWMTCal = item?.parent?.substring(0, 3) === 'Wal' || isCheckParentFolder;

			const condition = item.filter.condition;
			const futureDateFlag = condition.toLowerCase().includes('next');
			let value = item.filter.value;
			if (condition !== CUSTOM) {
				value = getDateRange(condition.split(',')[0], true, isWMTCal);
				value[0] = value[0].format(dateFormat);
			}

			const diff = moment(value[1], 'YYYY/MM/DD').diff(moment(value[0], 'YYYY/MM/DD'), dayL);
			let newStartDt = moment(value[1], 'YYYY/MM/DD')
				.clone()
				.subtract(SHRINK_WINDOW_RANGE, 'days')
				.format(dateFormat);
			let newEndDt = moment(value[1], 'YYYY/MM/DD').clone().add(1, dayL).format(dateFormat);

			if (futureDateFlag && isCheckParentFolder) {
				newStartDt = moment(value[0], 'YYYY/MM/DD').clone().format(dateFormat);
				newEndDt = moment(value[0], 'YYYY/MM/DD')
					.clone()
					.add(SHRINK_WINDOW_RANGE + 1, dayL)
					.format(dateFormat);
			}

			const tblName = getTableName(pView);
			const colName = getColumnName(
				pTemplate,
				pList,
				pSelectedList,
				pSelectedTmplData,
				item.businessName,
				item.parent
			);

			let tbl = tblName || 'vw_chnl_perf_item_fact_all_dly';

			if (WK_SPEC_TMPT.includes(Number(pTemplate))) {
				// Week table selection is same for store and DC inventory
				if (item.businessName === WEEK_KEY) {
					let itemTableWeekly = item.tableWeekly;
					if (!isWeekSel) {
						itemTableWeekly = itemTableWeekly?.replaceAll('wkly', 'dly');
					}
					// schedule arrival date - col name need to update for forecast
					if (diff > SHRINK_WINDOW_RANGE) {
						return {
							[`${itemTableWeekly}.${colName}`]: `${newStartDt} to ${newEndDt}`
						};
					} else {
						return {
							[`${itemTableWeekly}.${colName}`]: `${value[0]} to ${newEndDt}`
						};
					}
				}
				// if business name is Date
				tbl = item.table;
				if (!isWeekSel) {
					tbl = tbl?.replaceAll('wkly', 'dly');
				}
			}
			if (diff > SHRINK_WINDOW_RANGE) {
				/** As OTIF has lag of latest 2 weeks. Hence, we need to remove last week from fuzzy options.
				 * For custom, current and last wk will be disabled.
				 */
				if (OTIF_TMPT_LIST.includes(Number(pTemplate))) {
					let dts = getDateRange(FILTER_CONDITION_LABELS.WMT_LAST_WEEK, true, isWMTCal);
					if (moment(value[1]).isSameOrAfter(dts[0]) && moment(value[1]).isSameOrBefore(dts[1])) {
						/* Below param 2 => for Lastweek + 1 */
						let dts = wkDayRange(2);
						const sDt = moment(dts[0], 'YYYY/MM/DD').format('YYYY/MM/DD');
						const eDt = moment(dts[1], 'YYYY/MM/DD').format('YYYY/MM/DD');
						return { [`${tbl}.${colName[0]}`]: `${sDt} to ${eDt}` };
					}
				}
				return { [`${tbl}.${colName[0]}`]: `${newStartDt} to ${newEndDt}` };
			}
			return { [`${tbl}.${colName[0]}`]: `${value[0]} to ${newEndDt}` };
		} else {
			const validItem =
				SSIAllLinkRollupFolders.includes(item.folderName) ||
				item.technicalName === WM_ITEM_NUMBER_FIELD;
			if (validItem && pLinkItemActivity !== '' && pLinkItemActivity !== null) {
				return getFilterForAllLinkActivity(item, pLinkItemActivity);
			}

			// The preview object needs to be the same for both multi week selection or MTS which is why we check
			// for both is multi select (selecting multiple options in week) or isMTS which is the "Time selection"
			let isMultiWeek = pList?.find((el) => isMultiWeekSel(el, Number(pTemplate)));
			if (isMultiTimeSelection) {
				isMultiWeek = isMultiTimeSelection;
			}
			if (isMultiWeek) {
				const oldKey = Object.keys(item?.field);
				const colName =
					item?.dbtechnicalNameMultiTime ||
					Object.keys(item?.field || {})
						.toString()
						.split('.')[1];
				const multiWeekTable = item?.tableWeeklyMultiWindow
					? item?.tableWeeklyMultiWindow
					: isMultiWeek.tableWeeklyMultiWindow;
				return { [`${multiWeekTable}.${colName}`]: `${item?.field[oldKey]}` };
			}
			if (isWeekSel && WK_SPEC_TMPT.includes(Number(pTemplate))) {
				const oldKey = Object.keys(item?.field || {});
				const colName = Object.keys(item?.field || {})
					.toString()
					.split('.')[1];
				return { [`${item?.tableWeekly}.${colName}`]: `${item?.field[oldKey]}` };
			}
			return item?.field;
		}
	});

	if (fieldList === undefined) {
		fieldList = [];
	}

	const o = Object.assign({}, ...fieldList);

	return o;
};

const buildPreviewSelectedList = (_d, pTemplateData, pSelectedTemplate) => {
	const result = [];

	const potentialTempList = pTemplateData.filter((item) => {
		if (isCustomDataset(pSelectedTemplate)) {
			return item?.customDatasetId === pSelectedTemplate;
		} else {
			return item.templateName === getTmplName(pSelectedTemplate);
		}
	});
	const templateWithSameId = potentialTempList.find((temp) => temp.templateId == pSelectedTemplate);
	const template = templateWithSameId ? templateWithSameId : potentialTempList[0];
	const filtersWithValue = _d?.filtersWithValue;

	/** Although below object(_timeObj), append for all time attribute selection but will not impact in any calculation.
	 * Reason is we are not adding "field" attribute.
	 *
	 * This _timeObj is useful at the time of re-ordering the columns after Edit.
	 */
	const _timeObj = filtersWithValue?.find((el) => isCalFamily(el));
	let calParentName = _timeObj?.parent;

	// For MTS 2.0, we dont set a parent which is why it is undefined. So we set the calParentName to Walmart Calendar if it is MTS 2.0 since
	// MTS 2.0's parent will always be Walmart Calendar and not Gregorian calendar
	const isMTSAndFilterApplied = isMTSAndNotDefault(_timeObj);
	if (isMTSAndFilterApplied && !calParentName) {
		calParentName = WALMART_CALENDAR;
	}

	const fields = _d?.columns;

	let custAttrInd = 0;
	const getSelectedList = (businessName) => {
		// entire tmpl object
		Object.keys(template).forEach((key) => {
			// [key] should be 'dimension', 'measure' and 'time'
			if (Array.isArray(template[key])) {
				// Time does have same object for Walmart and Gregorian. Hence, need to iterate separately.
				if (key === 'time') {
					const timeParent = template[key].find((el) => el.businessName === calParentName);
					const timeObj = timeParent.subAttributes.find((el) => el.businessName === businessName);
					if (timeObj !== undefined) {
						// Adds the MTS localName to the filter if present
						const localName = _timeObj?.localName || null;
						if (localName !== null) {
							result.push({
								...timeObj,
								parent: calParentName,
								filter: _timeObj.filter,
								localName
							});
						} else {
							result.push({ ...timeObj, parent: calParentName, filter: _timeObj.filter });
						}
					}
				} else {
					const attributeObj = template[key].find((item) => item.businessName === businessName);
					if (attributeObj !== undefined) {
						/** Below selectedList need to update as below. This will help in column mapping in preview table. */

						if (key !== PARENT_CUST_ATTR) {
							result.push({ ...attributeObj, parent: key });
						} else {
							const prevTbl = attributeObj.prevTbl ? attributeObj.prevTbl : attributeObj.table;
							result.push({
								...attributeObj,
								prevTbl: prevTbl,
								table: `${prevTbl}${++custAttrInd}`,
								parent: key
							});
						}
					}
				}
			}
		});
	};

	fields?.map((businessName) => {
		getSelectedList(businessName);
	});

	return result;
};

const buildBusinessName = (pBussName, templateId) => {
	if (pBussName === DATE_KEY) {
		if ([...DC_TMPT_LIST].includes(Number(templateId))) {
			return `${pBussName} (Last 31 days only)`;
		}
	}

	if (pBussName === WEEK_KEY) {
		if (STR_ORDER_LIST.includes(Number(templateId))) {
			return 'Suggested Order Date';
		}

		if (STR_DEMAND_LIST.includes(Number(templateId))) {
			return 'Forecast Walmart Week';
		}
	}

	return pBussName;
};

const getTableName = (view) => {
	const tbl = {
		OMNI_SALES: 'vw_chnl_perf_item_fact_dly',
		OMNI_SALES_CATMAN: 'vw_chnl_perf_item_fact_all_dly',
		MERCHANT_OMNI_CATMAN: 'vw_merchant_item_fact_all',
		OMNI_SALES_MULTI_WINDOW: 'vw_chnl_perf_item_fact_dly',
		OMNI_SALES_CATMAN_MULTI_WINDOW: 'vw_chnl_perf_item_fact_all_dly',
		MERCHANT_OMNI_CATMAN_MULTI_WINDOW: 'vw_merchant_item_fact_all',
		STORE_ORDER_FORECAST: 'vw_chnl_perf_store_order_forecast_dly',
		STORE_ORDER_FORECAST_MERCHANT: 'vw_merchant_store_order_forecast_all_dly',
		STORE_ORDER_FORECAST_CATMAN: 'vw_chnl_perf_store_order_forecast_all_dly',
		STORE_DEMAND_FORECAST: 'vw_chnl_perf_store_demand_forecast_dly',
		STORE_DEMAND_FORECAST_MERCHANT: 'vw_merchant_store_demand_forecast_all_dly',
		STORE_DEMAND_FORECAST_CATMAN: 'vw_chnl_perf_store_demand_forecast_all_dly',
		OMNI_OTIF_SUPPLIER: 'vw_chnl_perf_omni_otif_dly',
		OMNI_OTIF_MERCHANT: 'vw_merchant_omni_otif_all_dly',
		MERCHANT_ECOM_INVENTORY_DAILY: 'vw_merchant_ecom_inv_all_dly',
		ECOM_INVENTORY_SUPPLIER_DAILY: 'vw_chnl_perf_ecom_inv_dly',
		ECOM_INVENTORY_CATMAN_DAILY: 'vw_chnl_perf_ecom_inv_all_dly',
		MERCHANT_STORE_MARKUP_AND_MARKDOWNS: 'vw_merchant_mumd_all_dly',
		STORE_MARKUP_AND_MARKDOWNS_CATMAN: 'vw_chnl_perf_mumd_all_dly',
		STORE_MARKUP_AND_MARKDOWNS: 'vw_chnl_perf_mumd_dly',
		ENTERPRISE_INVENTORY_SUPPLIER: 'vw_chnl_perf_enterprise_inventory',
		ENTERPRISE_INVENTORY_MERCHANT: 'vw_chnl_perf_enterprise_inventory',
		PURCHASE_ORDER_DAILY: 'vw_chnl_perf_purchase_order_dly',
		PURCHASE_ORDER_DAILY_MERCHANT: 'vw_merchant_purchase_order_all_dly',
		PURCHASE_ORDER_WEEKLY: 'vw_chnl_perf_purchase_order_dly',
		PURCHASE_ORDER_WEEKLY_MERCHANT: 'vw_merchant_purchase_order_all_dly',
		ECOM_BOTTLE_DEPOSITS: 'vw_chnl_perf_ecomm_item_sales_dly',
		ECOM_BOTTLE_DEPOSITS_CATMAN: 'vw_chnl_perf_ecomm_item_sales_all_dly',
		ECOM_BOTTLE_DEPOSITS_MERCHANT: 'vw_merchant_ecomm_item_sales_all_dly',
		TENDER_ANALYSIS: 'vw_chnl_perf_item_visit_tndr_cr_dly',
		BASIC_TENDER_ANALYSIS: 'vw_chnl_perf_basic_item_visit_tndr_dly',
		TENDER_ANALYSIS_CATMAN: 'vw_chnl_perf_item_visit_tndr_cr_all_dly',
		BASIC_CATMAN_TENDER_ANALYSIS: 'vw_chnl_perf_basic_item_visit_tndr_dly',
		TENDER_ANALYSIS_MERCHANT: 'vw_merchant_item_visit_tndr_cr_all_dly',
		ECOM_INSTOCK_MERCHANT: 'vw_merchant_ecom_instock_all_dly',
		ECOM_INSTOCK_SUPPLIER: 'vw_chnl_perf_ecomm_instock_dly',
		ECOM_INSTOCK_CATMAN: 'vw_chnl_perf_ecomm_instock_all_dly',
		REGISTER_SALES_DAILY: 'vw_chnl_perf_store_register_sales_dly',
		REGISTER_SALES_WEEKLY: 'vw_chnl_perf_store_register_sales_wkly',
		REGISTER_SALES_DAILY_CATMAN: 'vw_merchant_register_sales_dly',
		REGISTER_SALES_WEEKLY_CATMAN: 'vw_merchant_register_sales_wkly',
		REGISTER_SALES_DAILY_MERCHANT: 'vw_chnl_perf_store_register_sales_all_dly',
		REGISTER_SALES_WEEKLY_MERCHANT: 'vw_chnl_perf_store_register_sales_all_wkly'
	};
	return tbl[view];
};

const getColumnName = (tmptId, filterList, selectedList, selectedTmplData, bName, parent) => {
	if (
		isSSIAndDCDaily(selectedList, filterList) &&
		[...REGISTER_SALES_LIST, ...STR_TMPT_LIST].includes(Number(tmptId)) &&
		parent === WALMART_CALENDAR
	) {
		return [BUSINESS_DATE];
	}
	if (parent === GREGORIAN_CALENDAR) {
		let columnName = BUSINESS_DATE;
		const gregorianSubAttrs = selectedTmplData[0].time?.find(
			(timeObj) => timeObj?.businessName === GREGORIAN_CALENDAR
		)?.subAttributes;
		if (gregorianSubAttrs) {
			if (bName === DATE_KEY) {
				const filterAttribute = gregorianSubAttrs.find(
					(timeAttr) => timeAttr.businessName === DATE_KEY
				)?.technicalName;
				columnName = filterAttribute ? filterAttribute : columnName;
			} else {
				const filterAttribute = gregorianSubAttrs.find(
					(timeAttr) => timeAttr.businessName === WEEK_KEY
				)?.technicalName;
				columnName = filterAttribute ? filterAttribute : columnName;
			}
		}
		// For SSI, always Greg. calendar selections we need to use business date as fieldName/columnName
		if ([...STR_DEMAND_LIST, ...OTIF_TMPT_LIST].includes(Number(tmptId))) {
			columnName = BUSINESS_DATE;
		}
		if ([...ECOM_INVENTORY, ...ECOMM_INSTOCK_LIST].includes(Number(tmptId))) {
			// For eComm Inventory and eComm Instock, the Greg. calendar filter key should be REPORT_DATE always since BE only have one column called report_date
			columnName = REPORT_DATE;
		}
		return [columnName];
	}
	// Returning column name for Purchase Order time Period
	if (parent === '' && PURCHASE_ORDER_LIST.includes(Number(tmptId))) {
		const columnName = selectedTmplData[0].time[0].subAttributes.find(
			(item) => item.businessName === bName
		).technicalName;
		return [columnName];
	}
	const filterAttribute = selectedTmplData[0].time[0]?.subAttributes.filter((timeAttr) => {
		if (
			(bName === DATE_KEY && timeAttr.businessName === DATE_KEY) ||
			timeAttr.businessName === WEEK_KEY
		) {
			return timeAttr;
		}
	})[0].filterAttribute;
	return [filterAttribute] || [BUSINESS_DATE];
};

const countDimensionFilter = (filterList) => {
	return filterList.filter(
		(filter) =>
			filter.filter?.condition?.length > 0 && filter.parent === ATTRIBS_LOWERCASE.dimensions
	);
};

const validateDimFilters = (selectedList, filterList, templateNum) => {
	if (STR_TMPT_LIST.includes(templateNum)) {
		const storeDims = ['store_name', 'store_number'];
		const itemDims = [
			'item_name',
			'walmart_item_number',
			'walmart_upc_number',
			'prime_item_number',
			'all_links_item_description',
			'all_links_item_number',
			'all_links_store_item_id',
			'consumer_id',
			'consumer_item_description',
			'consumer_item_number',
			'item_description_2',
			'price_look_up_number',
			'product_description',
			'store_item_id',
			'walmart_upc_description',
			'warehouse_pack_upc_number'
		];

		const selectedStoreDims = selectedList.find((item) => storeDims.includes(item.technicalName));
		const selectedItemDims = selectedList.find((item) => itemDims.includes(item.technicalName));

		if (selectedStoreDims && selectedItemDims) {
			const oneLogicalCondition = filterList.find((filter) => {
				if (filter.field) {
					const fieldVal = filter.field[Object.keys(filter.field)[0]];
					return (
						filter.filter?.condition?.length > 0 &&
						filter.parent === ATTRIBS_LOWERCASE.dimensions &&
						!fieldVal.includes('NULL')
					);
				}
				return false;
			});

			return oneLogicalCondition ? true : false;
		}
	}
	return true;
};

const getParentAndDftFilter = (o) => {
	let parentCompObj = {};
	let defaultFilter = {};
	let catmanUserIdObj = {};
	for (const key in o) {
		const colName = key.split('.')[1];
		if (['parent_cmpny_nm', 'luminate_cmpny_id'].includes(colName)) {
			parentCompObj = {
				['luminate_cmpny_id']: o[key]
			};
		}

		if (colName === 'flag' && ['Y', 'N'].includes(o[key])) {
			defaultFilter = {
				[key]: o[key]
			};
		}

		if (colName === 'catman_user_id') {
			catmanUserIdObj = {
				[key]: o[key]
			};
		}
	}

	return { ...parentCompObj, ...defaultFilter, ...catmanUserIdObj };
};

const createFolders = (result, customAttribute, isCannedReport, isStudent, disableAttribute) => {
	const hierarchyFolders = Object.entries(
		result[0]?.folderNames?.sort() ?? result[0]?.tables?.sort()
	).reduce((prev, curr) => {
		const obj = { name: curr[1], dimensions: [], measures: [], disabledDim: [], disabledMsr: [] };
		prev.push(obj);
		return prev;
	}, []);
	result[0]?.dimensions?.forEach((item) => {
		const folder = hierarchyFolders.filter((folder) => folder.name === item.folderName)[0];
		const checkStudent = isStudent && item?.isDisabledForStudent;
		if (disableAttribute && (item.isDisabled || checkStudent)) {
			folder?.disabledDim.push(item);
		} else {
			folder?.dimensions.push(item);
		}
	});
	result[0]?.measures?.forEach((item) => {
		const folder = hierarchyFolders.filter((folder) => folder.name === item.folderName)[0];
		const checkStudent = isStudent && item?.isDisabledForStudent;
		if (disableAttribute && (item.isDisabled || checkStudent)) {
			folder?.disabledMsr.push(item);
		} else {
			folder?.measures.push(item);
		}
	});
	if (result[0].time) {
		hierarchyFolders.unshift({
			name: TIME,
			periods: result[0]?.time
		});
	}
	if (customAttribute.length > 0 && !isCannedReport) {
		hierarchyFolders.push({
			name: CUSTOM_ATTRIBUTE,
			customAttribute: customAttribute
		});
	}

	return hierarchyFolders;
};

/**
 * Remove items from the Preview Filter Panel
 * according to the conditions
 */
const removeItemsFromFilterList = (templateId, filterList = []) => {
	/**
	 * Order Forecast Enhancement
	 * Remove `Distribution Center Number` from Filter
	 */
	if (STR_ORDER_LIST.includes(templateId)) {
		const itemsToRemove = ['Distribution Center Number'];
		const result = filterList.filter(
			(attributeItem) => !itemsToRemove.includes(attributeItem.businessName)
		);
		return result;
	}
	return filterList;
};

const getUpdatedFilters = (filterList, selTmpl, selTempData, userPersona) => {
	const selectedView = getSelectedView(filterList, selTmpl, selTempData);
	const isMultiWeek = filterList?.find((el) => isMultiWeekSel(el, Number(selTmpl)));

	const copiedList = deepClone(filterList);
	let list = [];
	copiedList.forEach((item, index) => {
		let newItem = undefined;
		if (isCalFamily(item)) {
			newItem = selTempData.time
				.find((data) => data.businessName === item.parent)
				.subAttributes.find((data) => data.businessName === item.businessName);
		} else if (item.parent === ATTRIBS_LOWERCASE.dimensions) {
			newItem = selTempData.dimensions.find((data) => data.businessName === item.businessName);
		} else {
			newItem = selTempData.measures.find((data) => data.businessName === item.businessName);
		}
		if (newItem) {
			newItem = {
				...newItem,
				parent: item.parent,
				filter: {
					condition: item.filter.condition,
					value: item.filter.value,
					extraValue: item.filter?.extraValue
				}
			};

			/**
			 * We need this part to make sure that value of the time filter is in valid format
			 * (e.g. shared report from quick reports have old format of [-4, -1])
			 */
			if (isCalFamily(item)) {
				const val = item.field[Object.keys(item.field)];
				newItem.filter.value = [val];
			}
			const field = build(newItem, selectedView, userPersona, isMultiWeek);
			copiedList[index] = { ...newItem, field };
			list.push(copiedList[index]);
		}
	});

	return list;
};

const getSelectedView = (filterList, selTmpl, selTempData) => {
	let selectedView = selTempData.view;
	const isWeekSel = filterList?.find((el) => el.businessName === WEEK_KEY);
	const isMultiWeek = filterList?.find((el) => isMultiWeekSel(el, Number(selTmpl)));
	if (isWeekSel && selTempData.viewWeekly) {
		selectedView = selTempData.viewWeekly;
	}
	if (isMultiWeek && selTempData.viewWeeklyMultiWindow) {
		selectedView = selTempData.viewWeeklyMultiWindow;
	}

	return selectedView;
};

const isDefaultFilter = (filter, selectedList, sbuDBTechNames, templateId) => {
	if (
		selectedList.find((item) =>
			SSI_STORE_TRAIT_ATTRS.ATTR_SELECTION_TECHNICAL_NAME.includes(item.technicalName)
		) &&
		SSI_STORE_TRAIT_ATTRS.MENDATORY_FILTER_TECHNICAL_NAME.includes(filter.technicalName)
	) {
		return true;
	}
	// Applying default filters for ENTERPRISE INVENTORY (EI) template
	if (
		ENTERPRISE_INVENTORY.includes(Number(templateId)) &&
		EIDefaultFilters.includes(filter.technicalName)
	) {
		return true;
	}

	if (
		PURCHASE_ORDER_LIST.includes(Number(templateId)) &&
		PO_DEFAULT_FILTERS.includes(filter.technicalName)
	) {
		return true;
	}

	return isCalFamily(filter) || sbuDBTechNames.includes(filter.dbtechnicalName);
};

const enableFilter = (o, tmpltId, _parent) => {
	/**
	 * SSI - Few derived metric filter need to be disabled
	 */

	if (STR_TMPT_LIST.includes(Number(tmpltId))) {
		const derivedMtrcList = [
			'dollar_per_store_per_week_or_per_day_this_year',
			'net_maintained_margin_percent_this_year',
			'total_store_on_hand_adjustment_retail_amount',
			'net_maintained_margin_percent_last_year',
			'dollar_per_store_per_week_or_per_day_last_year',
			'total_store_on_hand_adjustment_quantity',
			'gross_maintained_margin_percent_last_year',
			'gross_maintained_margin_percent_this_year',
			'units_per_store_per_week_or_per_day_last_year',
			'units_per_store_per_week_or_per_day_this_year'
		];

		if (derivedMtrcList.includes(o.technicalName)) {
			return false;
		}
	}
	/** Filter icon should not be visible for any measures for canned report
	 * OR if Item Access Code
	 */
	if (
		(CANNED_REPORT_LIST.includes(Number(tmpltId)) && _parent === ATTRIBS_LOWERCASE.measures) ||
		o.businessName === ITEM_ACCESS_TYPE
	) {
		return false;
	}

	if (ENTERPRISE_INVENTORY.includes(Number(tmpltId))) {
		if (['Business Date', 'Last Updated Time'].includes(o.businessName)) {
			return false;
		}
	}

	/* Order Forecast attribute, filter not allowed */
	if (STR_ORDER_LIST.includes(Number(tmpltId)) && o.businessName === 'Distribution Center Number') {
		return false;
	}

	/** For OMNI OTIF Template, below fields should not be allowed to be filtered */
	if (OTIF_TMPT_LIST.includes(Number(tmpltId))) {
		const attrWithNoFilters = [
			'charge_status',
			'charged_ind',
			'p1e_ind',
			'has_accountability_info'
		];
		if (attrWithNoFilters.includes(o.dbtechnicalName)) {
			return false;
		}
	}

	/* Purchase Order, filter not allowed for Walmart Week time period*/
	if (PURCHASE_ORDER_LIST.includes(Number(tmpltId)) && o.businessName === 'Walmart Week') {
		return false;
	}

	return o.dataType !== 'time';
};

const updateDtObj = (list = []) => {
	/**
	 * as per current requirement for demand forecast checking if start date is after the start of last 5th week
	 * then proceed else return list as it is.
	 */
	const _dt = moment().clone().subtract(5, weekL).endOf(weekL);
	let _o = list.find((el) => isCalFamily(el));

	if (_o.filter.condition !== CUSTOM) {
		return list;
	}
	const startCustomDt = moment(_o.filter.value[0]).format('YYYY/MM/DD');
	if (moment(startCustomDt).isAfter(_dt)) {
		return list;
	}

	let updatedAppliedFilter = list.filter((el) => !isCalFamily(el));
	_o['field'] = { [`${_o.tableWeekly}.${_o.filterAttribute}`]: '1 weeks' };
	const dValue = _wm().getCurrWkDate(true);
	const dateFormat = 'MM/DD/YYYY';
	const _filter = {
		condition: 'WMT Current week',
		value: ['1 weeks'],
		extraValue: [moment(dValue[0]._d).format(dateFormat), moment(dValue[1]._d).format(dateFormat)]
	};
	_o.filter = _filter;
	list = [...updatedAppliedFilter, _o];
	return list;
};

const transformPinnedAttribute = (pinnedAttribute, templateData, searchQuery = '') => {
	const { dimensions, measures } = templateData;
	const result = {
		name: 'Pinned data',
		dimensions: [],
		measures: []
	};
	// On Search, return only attributes with search query
	if (searchQuery) {
		dimensions?.map(({ businessName, ...rest }) => {
			if (
				pinnedAttribute?.dimensions?.includes(businessName) &&
				businessName.toLowerCase()?.includes(searchQuery.toLowerCase())
			) {
				result.dimensions.push({ businessName, ...rest });
			}
		});
		measures?.map(({ businessName, ...rest }) => {
			if (
				pinnedAttribute?.metrics?.includes(businessName) &&
				businessName.toLowerCase()?.includes(searchQuery.toLowerCase())
			) {
				result.measures.push({ businessName, ...rest });
			}
		});
		return result;
	}
	// Normal case return all pinned attributes
	dimensions?.map(({ businessName, ...rest }) => {
		if (pinnedAttribute?.dimensions?.includes(businessName)) {
			result.dimensions.push({ businessName, ...rest });
		}
	});
	measures?.map(({ businessName, ...rest }) => {
		if (pinnedAttribute?.metrics?.includes(businessName)) {
			result.measures.push({ businessName, ...rest });
		}
	});
	return result;
};

/* Pivot related util methods */
const splitTableHeadersForTimeAcross = (currentHeaders, timeSelections) => {
	let newHeaders = [];
	if (timeSelections.length === 0 || currentHeaders.length === 0) {
		return currentHeaders;
	}
	// Format Custom time selections key to 'Custom time X'
	timeSelections.forEach((element, index) => {
		if (element?.toLocaleLowerCase().includes('custom')) {
			timeSelections[index] = `Custom time ${element?.split('_')[2] || ''}`;
		}
	});

	if (timeSelections.length > 0) {
		//for timeAcross, measures will be filtered out
		currentHeaders.forEach((header) => {
			const allowedHeaders =
				header?.item?.localName !== MULTI_TIME_SELECTION &&
				!PIVOT_SINGLE_TIME_VALUES.includes(header?.item?.technicalName) &&
				header?.item?.parent !== ATTRIBS_LOWERCASE.measures;
			if (allowedHeaders) {
				if (!contains(newHeaders, header)) {
					// Dimensions need not to be splitted
					newHeaders.push({
						...header
					});
				}
			}
		});
		timeSelections.forEach((timeSelection) => {
			newHeaders.push({
				item: { parent: 'times' },
				isDeleteColAllowed: false,
				isFilterColAllowed: false,
				field: `${timeSelection?.toLocaleLowerCase()?.split(' ').join('_')}`,
				headerName: `${timeSelection}`
			});
		});
		newHeaders.push({
			item: { parent: 'placeholder' },
			isDeleteColAllowed: false,
			isFilterColAllowed: false,
			field: 'timeAcrossDataTypePlaceHolder',
			headerName: 'Data Type'
		});
	}
	return newHeaders;
};
/**
 * Split the Table headers based on the timeSelections('Yesterday', 'WMT Month to date' etc)
 *
 * For example:
 * headers ['Dim1', 'Metric1', 'Metric2', 'Custom Attr1']
 * timeSelections ['Yesterday']
 * Result, New headers => ['Dim1', 'Yesterday - Metric1', 'Yesterday - Metric2', 'Custom Attr1']
 */
const splitTableHeadersForPivot = (currentHeaders, timeSelections) => {
	let newHeaders = [];
	if (timeSelections.length === 0 || currentHeaders.length === 0) {
		return currentHeaders;
	}
	// Format Custom time selections key to 'Custom time X'
	timeSelections.forEach((element, index) => {
		if (element?.toLocaleLowerCase().includes('custom')) {
			timeSelections[index] = `Custom time ${element?.split('_')[2] || ''}`;
		}
	});

	if (timeSelections.length > 0) {
		timeSelections.forEach((timeSelection) => {
			currentHeaders.forEach((header) => {
				// Remove 'Multi-time Selection' & other Single Time attributes from headers
				const allowedHeaders =
					header?.item?.localName !== MULTI_TIME_SELECTION &&
					!PIVOT_SINGLE_TIME_VALUES.includes(header?.item?.technicalName);
				// Multiply all Metrics(measures) with selected time frames
				if (allowedHeaders) {
					if (header?.item?.parent === ATTRIBS_LOWERCASE.measures) {
						newHeaders.push({
							...header,
							isDeleteColAllowed: false,
							isFilterColAllowed: false,
							field: `${header?.field}_${timeSelection?.toLocaleLowerCase()?.split(' ').join('_')}`,
							headerName: `${timeSelection} - ${header?.headerName}`
						});
					} else if (!contains(newHeaders, header)) {
						// Dimensions need not to be splitted
						newHeaders.push({
							...header
						});
					}
				}
			});
		});
	}
	return newHeaders;
};

const hasPivotedColumn = (value) => [PIVOT_MTS_VALUE, ...PIVOT_SINGLE_TIME_VALUES].includes(value);
const hasTimeAcross = (opts) => {
	return hasPivotedColumn(opts?.pivotColumn) && opts?.isTimeAcross;
};
const TImeFilterCountMap = {
	[FILTER_CONDITION_LABELS.WMT_LAST_WEEK]: 1,
	[FILTER_CONDITION_LABELS.WMT_LAST_2_WEEKS]: 2,
	[FILTER_CONDITION_LABELS.WMT_LAST_4_WEEKS]: 4,
	[FILTER_CONDITION_LABELS.WMT_LAST_13_WEEKS]: 13,
	[FILTER_CONDITION_LABELS.WMT_LAST_26_WEEKS]: 26,
	[FILTER_CONDITION_LABELS.WMT_LAST_52_WEEKS]: 52,
	[FILTER_CONDITION_LABELS.LAST_MONTH]: 1,
	[FILTER_CONDITION_LABELS.LAST_2_MONTHS]: 2,
	[FILTER_CONDITION_LABELS.LAST_3_MONTHS]: 3,
	[FILTER_CONDITION_LABELS.LAST_6_MONTHS]: 6,
	[FILTER_CONDITION_LABELS.WMT_LAST_QUARTER]: 1,
	[FILTER_CONDITION_LABELS.WMT_LAST_2_QUARTERS]: 2
};

const SingleTimeDateTechNames = [
	PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_DATE,
	PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_DC_DATE,
	PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_MUMD_DATE,
	PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_ECOM_INV_DATE
];

/**
 * Calculate time filter count for pivot,
 * Also Dimension, snap shot hour attribute is considered as time filter for EI template
 */
const findAppliedTimeFilterCountForPivot = (filterList = []) => {
	let result = 0;
	const allowedParents = [WALMART_CALENDAR, ATTRIBS_LOWERCASE.dimensions];
	const appliedTimeFilter = filterList.find(
		(item) =>
			item?.field &&
			allowedParents.includes(item?.parent) &&
			PIVOT_SINGLE_TIME_VALUES.includes(item?.technicalName)
	);
	if (!appliedTimeFilter) {
		return result;
	}
	/**
	 * Single time Date
	 * The count would be the total Number of of days.
	 */
	if (SingleTimeDateTechNames.includes(appliedTimeFilter?.technicalName)) {
		const filterConditions = Object.keys(TImeFilterCountMap);
		if (filterConditions.includes(appliedTimeFilter?.filter?.condition)) {
			// No. of Weeks * 7 Days
			result = TImeFilterCountMap[appliedTimeFilter?.filter?.condition] * 7;
		} else {
			// For other selection: Yesterday, WMT Week to date, Last Weekend[Fri-Sat-Sun] & Custom
			const isCustom = appliedTimeFilter?.filter?.condition === 'Custom';
			const date1 = isCustom
				? appliedTimeFilter?.filter?.value[0]
				: appliedTimeFilter?.filter?.extraValue[0];
			const date2 = isCustom
				? appliedTimeFilter?.filter?.value[1]
				: appliedTimeFilter?.filter?.extraValue[0];
			result = getDateDifference(new Date(date1), new Date(date2)) + 1;
		}
		return result;
	}
	/**
	 * Multi time selection
	 */
	if (appliedTimeFilter?.localName === MULTI_TIME_SELECTION) {
		result = Object.keys(appliedTimeFilter?.mts ?? {}).length || 0;
		return result;
	}
	const multiTimeAttrs = ['walmart_calendar_week', 'walmart_year_and_week'];
	const singleTimeAttrs = PIVOT_SINGLE_TIME_VALUES.filter((e) => !multiTimeAttrs.includes(e));
	/**
	 * If multiple filters are applied, simply take the length of filters
	 * Otherwise, if single filter is applied, take the count from TImeFilterCountMap
	 */
	if (multiTimeAttrs.includes(appliedTimeFilter?.technicalName)) {
		const conditions = appliedTimeFilter?.filter?.condition.split(',');
		if (conditions.length > 1) {
			result = conditions.length;
		} else if (conditions.length === 1) {
			result = TImeFilterCountMap[conditions[0]] || 1;
		}
		return result;
	}
	if (singleTimeAttrs.includes(appliedTimeFilter?.technicalName)) {
		const condition = appliedTimeFilter?.filter?.condition;
		result = TImeFilterCountMap[condition] || 1;
		return result;
	}
	return result;
};

/**
 * @params
 * selectedList - List of Columns selected,
 * filterList - List of applied filters
 *
 * This function must be used for column count calculation in Pivot applying scenarios
 * Calculate total no.of columns using the formula, if user is applying the Pivot.
 */
const calculateTotalColumnCount = (selectedList = [], filterList = [], isTimeAcross = false) => {
	const timeFilterCount = findAppliedTimeFilterCountForPivot(filterList);

	// If user has no time filter selected then return selected column's count
	if (timeFilterCount === 0) {
		return selectedList?.length || 0;
	}
	/**
	 * When Time filter is selected with Pivot application, then return the count based on the formula
	 * => dimensionCount + customAttrCount + metricsCount * timeFilterCount
	 */
	const selectedAttributeCount = selectedList.reduce(
		(countObj, item) => {
			if (item?.parent === ATTRIBS_LOWERCASE.dimensions) {
				return {
					...countObj,
					dimensions: countObj.dimensions + 1
				};
			}
			if (item?.parent === ATTRIBS_LOWERCASE.measures) {
				return {
					...countObj,
					measures: countObj.measures + 1
				};
			}
			if (item?.parent === ATTRIBS_LOWERCASE.customAttribute) {
				return {
					...countObj,
					customAttribute: countObj.customAttribute + 1
				};
			}
			return countObj;
		},
		{
			dimensions: 0,
			measures: 0,
			customAttribute: 0
		}
	);
	if (isTimeAcross) {
		const measureTimeFilterCount = selectedAttributeCount.measures ? timeFilterCount : 0;
		return (
			selectedAttributeCount.dimensions +
			selectedAttributeCount.customAttribute +
			measureTimeFilterCount
		);
	}
	return (
		selectedAttributeCount.dimensions +
		selectedAttributeCount.customAttribute +
		selectedAttributeCount.measures * timeFilterCount
	);
};

/**
 * isVariantAttr,
 * isVariantAttrInTheList
 * Following methods will return Boolean true or false if the input value or array of values are Variant attributes
 */
const isVariantAttr = (value) => [...VARIANT_ATTRTIBUTES].includes(value);
const isVariantAttrInTheList = (list) => list.some((item) => isVariantAttr(item?.technicalName));
const isVariantID = (value) =>
	VARIANT_ATTRTIBUTES[0] === value || value.includes(VARIANT_ATTRTIBUTES[0]);
const isVariantIDInTheList = (list) => list.some((item) => isVariantID(item?.technicalName));

export {
	getRequestBody,
	buildShrinkTimeWindow,
	buildForecastWk,
	buildCustomAttrList,
	buildPreviewSelectedList,
	updateFieldKey,
	buildBusinessName,
	getTableName,
	countDimensionFilter,
	validateDimFilters,
	getParentAndDftFilter,
	createFolders,
	isMTSAppliedRowWise,
	convertRowToColMTS,
	removeItemsFromFilterList,
	getUpdatedFilters,
	getSelectedView,
	isDefaultFilter,
	enableFilter,
	updateDtObj,
	hasPivotedColumn,
	hasTimeAcross,
	transformPinnedAttribute,
	calculateTotalColumnCount,
	splitTableHeadersForPivot,
	splitTableHeadersForTimeAcross,
	findAppliedTimeFilterCountForPivot,
	isVariantID,
	isVariantIDInTheList,
	isVariantAttr,
	isVariantAttrInTheList,
	getUpdatedSubTemplateDetails
};
